export const LocalStorageKeys = {
  Authorization: 'Authorization',
  Impersonator: 'impersonator',
  SessionDeadline: 'SessionDeadline',
  PreviousUrl: 'previousUrl',
  LastLanguage: 'lastLanguage',
  FilterState: 'filterState'
} as const;
